import { SelectOptionType } from '@octano/global-ui';
import { useCallback } from 'react';

import { getNonStructuredAssistantsRequest } from '../../api/requests/sectionsMaintainer';

export const useSearchNonStructuredAssistant = () => {
  return useCallback(async (searchText: string): Promise<
    SelectOptionType[]
  > => {
    const { data } = await getNonStructuredAssistantsRequest(searchText);
    if (data) {
      return data.map((assist) => ({
        value: assist.id,
        label: assist.account?.fullName ?? '',
      }));
    }
    return [];
  }, []);
};
